import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '@/lib/api';

export function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  // After token exchange completes, hit /api/me to decide where to go.
  // Pass id_token explicitly: the module-level tokenGetter is set in a
  // useEffect that may not have run yet by the time this query fires.
  const idToken = auth.user?.id_token;
  const profile = useQuery({
    queryKey: ['me', idToken ? 'authed' : 'anon'],
    queryFn: () => api.getMe(idToken),
    enabled: auth.isAuthenticated && !!idToken,
    retry: false,
  });

  useEffect(() => {
    console.log('[auth-callback]', {
      authIsLoading: auth.isLoading,
      authIsAuthenticated: auth.isAuthenticated,
      hasIdToken: !!auth.user?.id_token,
      profileIsLoading: profile.isLoading,
      profileData: profile.data,
      profileError: profile.error,
    });
    if (auth.isLoading || profile.isLoading) return;
    if (!auth.isAuthenticated) return;

    if (profile.error instanceof ApiError && profile.error.status === 404) {
      navigate('/welcome', { replace: true });
    } else if (profile.data) {
      navigate('/', { replace: true });
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.user?.id_token, profile.isLoading, profile.data, profile.error, navigate]);

  return (
    <div className="p-12 text-center text-sm text-muted-foreground">
      Signing you in…
    </div>
  );
}
